import React from 'react';
import {loadable} from 'router/routes';
import CityAPI from 'api/city';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import City from './City';
import DestinationAPI from 'api/destination';
import Destination from './Destination';
import AirportAPI from 'api/airport';
import SearchAirportPage from './SearchAirport';
import {createCleanedData, fetchCleanedData} from 'router/router-actions';

const SearchMobile = loadable(() => import('search/SearchMobile'));
const SearchDesktop = loadable(() => import('search/SearchDesktop'));
const SearchAirport = loadable(() => import('search/airport/SearchAirport'));

// eslint-disable-next-line react/prop-types
const Search = ({configData, isMonthly, destination}) => {
    const {isMobile} = configData;

    if (destination && destination.airport && !isMonthly) {
        return <SearchAirport />;
    } else {
        return isMobile ? <SearchMobile /> : <SearchDesktop />;
    }
};

async function getCitySlug(cityId, searchParams) {
    if (!isEmpty(searchParams)) {
        const {
            page_info: {
                setup: {
                    city: {slug},
                },
            },
        } = searchParams;

        return slug;
    }

    const {slug} = await CityAPI.getById(cityId);

    return slug;
}

const AirportSearchInitialState = ({state, citySlug, destination, query}) => {
    const {
        relative_url: slug,
        airport: {iata_code: iataCode},
    } = destination;

    return SearchAirportPage.getInitialState({
        state: {
            ...state,
            destination: {data: destination},
        },
        params: {city: citySlug, slug, iata: iataCode},
        query,
    });
};

Search.getInitialState = async ({state, query, route, cookies}) => {
    const {
        location: {state: {searchParams} = {}},
    } = route;

    if (!isNil(query['city-id'])) {
        const cityId = query['city-id'];
        const city = await getCitySlug(cityId, searchParams);

        return City.getInitialState({state, params: {city}, query, cookies});
    } else if (!isNil(query['destination-id'])) {
        const destinationId = query['destination-id'];
        const destination = await DestinationAPI.get(destinationId).then(
            res => res.data.data
        );
        const {
            relative_url: slug,
            spothero_city: cityId,
            airport,
        } = destination;
        const citySlug = await getCitySlug(cityId, searchParams);

        if (airport) {
            return AirportSearchInitialState({
                state,
                citySlug,
                destination,
                query,
            });
        } else {
            return Destination.getInitialState({
                state: {
                    ...state,
                    destination: {data: destination},
                },
                params: {city: citySlug, slug},
                query,
                cookies,
            });
        }
    } else if (!isNil(query['airport-code'])) {
        const iataCode = query['airport-code'];
        const {
            data: {data: destination},
        } = await AirportAPI.getBySlug(iataCode);
        const {spothero_city: cityId} = destination;
        const citySlug = await getCitySlug(cityId, searchParams);

        return AirportSearchInitialState({
            state,
            citySlug,
            destination,
            query,
        });
    } else if (!isEmpty(searchParams)) {
        // `searchParams` is passed through the location 'state' in order to route using search metadata

        const {city, search: searchState} = state;

        return createCleanedData({
            currentCity: city,
            cleanedParams: searchParams,
            currentSearchState: searchState,
        });
    }

    return fetchCleanedData({state, route});
};

export default Search;
